import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid, Card, Typography, Button } from "@arco-design/web-react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { Feed } from "../DashBoard/partials/Feed/Feed";

import { endpoints } from "../../api/endpoints";
import { Meeting } from "../../models/Meeting";
import { Banner } from "../../components/Banner";
import { GuestHomeConversionBanner } from "../../components/GuestHomeConversionBanner/GuestHomeConversionBanner";
import { MeetingCard } from "../../components/MeetingCard";
import { PersonCard } from "../../components/PersonCard";
import { User } from "../../models/Person";
import { routes } from "../../routes/routes";
import { RootState } from "../../store/store";
import { getButtonColor, getButtonTextColor } from "../../utils/cssVariables";
import { filterDirectoryProfiles } from "../../utils/filterDirectoryProfiles";

const Row = Grid.Row;
const Col = Grid.Col;

export const DashboardLegacy = () => {
  const { t } = useTranslation();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const location = useLocation();

  const user = useSelector((state: RootState) => state.user.user);
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [profiles, setProfiles] = useState<User[]>([]);
  const navigate = useNavigate();

  const getMeetings = async () => {
    axios
      .get(`${endpoints.meetings}?timezone=${timezone}`)
      .then((response) => {
        setMeetings(response.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getMeetings();
  }, []);

  const getProfiles = async () => {
    axios
      .get(`${endpoints.getRandomMentors}`)
      .then((response) => {
        setProfiles(filterDirectoryProfiles(response.data.mentors));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getProfiles();
  }, []);

  // Handle scroll to feed section when hash is present
  useEffect(() => {
    if (location.hash === '#feed') {
      const feedElement = document.getElementById('feed');
      if (feedElement) {
        feedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  return (
    <div style={{ width: "100%" }}>
      <GuestHomeConversionBanner />

      <Banner />

      {!user?.isAdmin && <Card className="card-with-icon-hover own-card" style={{ marginTop: 20 }}>
        <Typography.Title
          heading={3}
          style={{
            textAlign: "left",
            margin: "0 0 4px 0",
            wordBreak: "break-word",
            textTransform: "uppercase",
          }}
        >
          {t('home_page.upcoming_meetings')}
        </Typography.Title>
        <Row style={{ marginBottom: 20 }}>{t('home_page.meeting_disclaimer')}</Row>

        {meetings.length > 0 && (
          <>
            <div className="upcoming-meetings-grid">
              {meetings.map((meeting, index) => (
                <MeetingCard key={`meeting-${index}`} meeting={meeting} onCancelMeeting={getMeetings} />
              ))}
            </div>
            <div>{t('home_page.meetings_info')} ({timezone})</div>
          </>
        )}
        {meetings.length === 0 && (
          <Typography.Text style={{ textAlign: "left", width: "100%" }}>
            {t('home_page.no_meetings')} 
            <br />
            <Button
              onClick={() => navigate(routes.SEARCH)}
              style={{
                marginTop: 10,
                color: getButtonTextColor(),
                backgroundColor: getButtonColor(),
              }}
              size={"large"}
              shape={"round"}
            >
              {t('home_page.search_meetings_button')} 
            </Button>
          </Typography.Text>
        )}
      </Card>}

      <Card className="card-with-icon-hover own-card" style={{ marginTop: 20 }}>
        <Button
          onClick={() => navigate(routes.SEARCH)}
          style={{
            color: getButtonTextColor(),
            backgroundColor: getButtonColor(),
            float: "right",
          }}
          size={"large"}
          shape={"round"}
        >
          {t('home_page.search_mentors_button')} 
        </Button>
        <Typography.Title
          heading={3}
          style={{
            textAlign: "left",
            margin: "0 0 20px 0",
            wordBreak: "break-word",
            textTransform: "uppercase",
          }}
        >
          {t('home_page.featured_mentors')} 
        </Typography.Title>

        <Row
          style={{ marginBottom: 20, marginLeft: 10, marginRight: 10 }}
          gutter={20}
        >
          {profiles?.map((profile, index) => (
            <Col
              key={`meeting-${index}`}
              xs={24}
              sm={12}
              md={8}
              lg={8}
              xl={8}
              style={{ marginBottom: 20 }}
            >
              <PersonCard person={profile} />
            </Col>
          ))}
        </Row>
      </Card>
      <div id="feed">
        <Feed user={user} />
      </div>
    </div>
  );
};
